import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'pengalamanKerja'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const pengalamanKerjaCreate = 'Kepegawaian/PengalamanKerja/create/'
export const pengalamanKerjaList = 'Kepegawaian/PengalamanKerja/list/'
export const pengalamanKerjaDetail = 'Kepegawaian/PengalamanKerja/detail/'
export const pengalamanKerjaUpdate = 'Kepegawaian/PengalamanKerja/update/'
export const pengalamanKerjaInactive = 'Kepegawaian/PengalamanKerja/inactive/'
export const pengalamanKerjaActive = 'Kepegawaian/PengalamanKerja/active/'
export const pengalamanKerjaApprove = 'Kepegawaian/PengalamanKerja/approve/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}